import { api } from './api';
import { API_ENDPOINTS } from './endpoints';

export interface Admin {
  id: number;
  name: string;
  email: string;
  email_verified_at?: string;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string;
  is_active: boolean;
}

export const adminsService = {
  getAll: (params?: any) => api.get(API_ENDPOINTS.ADMINS.INDEX, { params }),
  
  getById: (id: number | string) => api.get(API_ENDPOINTS.ADMINS.SHOW(Number(id))),

  create: (data: any) => 
    api.post(API_ENDPOINTS.ADMINS.STORE, data),
  
  update: (id: number | string, data: any) => 
    api.put(API_ENDPOINTS.ADMINS.UPDATE(Number(id)), data),
    
  activate: (id: number | string) => 
    api.post(API_ENDPOINTS.ADMINS.ACTIVATE(Number(id))),
    
  deactivate: (id: number | string) => 
    api.post(API_ENDPOINTS.ADMINS.DEACTIVATE(Number(id))),
};
